import { playSound } from '@/engine/audio';

// play click sound on any click
window.addEventListener('click', () => {
	playSound({ name: 'click' });
});
